module.exports = __webpack_public_path__ + "img/jiakao.bb1b97d0.png";